var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamingFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.978,
    height: 20.561,
    viewBox: "0 0 27.978 20.561",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_8687342_ic_fluent_live_regular_iconqwe",
    "data-name": "8687342_ic_fluent_live_regular_iconqwe",
    transform: "translate(-2 -4.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16035",
    "data-name": "Path 16035",
    d: "M6.114,4.434a.832.832,0,0,1,1.177.018.924.924,0,0,1-.02,1.3,12.24,12.24,0,0,0,.261,17.442.923.923,0,0,1,.04,1.316.831.831,0,0,1-1.158.035,13.989,13.989,0,0,1-.3-20.108Z",
    fill: "#2fda7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16036",
    "data-name": "Path 16036",
    d: "M15.224,5.75a.924.924,0,0,1-.02-1.3.832.832,0,0,1,1.177-.018,13.989,13.989,0,0,1-.3,20.108.831.831,0,0,1-1.157-.035.923.923,0,0,1,.04-1.316A12.24,12.24,0,0,0,15.224,5.75Z",
    transform: "translate(9.482)",
    fill: "#2fda7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16037",
    "data-name": "Path 16037",
    d: "M7.353,6.187A.812.812,0,0,1,8.5,6.213a.953.953,0,0,1-.03,1.33,7.869,7.869,0,0,0,.25,11.206.952.952,0,0,1,.063,1.357.809.809,0,0,1-1.117.05A9.617,9.617,0,0,1,7.353,6.187Z",
    transform: "translate(1.872 1.32)",
    fill: "#2fda7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16038",
    "data-name": "Path 16038",
    d: "M13.473,7.543a.953.953,0,0,1-.03-1.33.812.812,0,0,1,1.147-.027,9.617,9.617,0,0,1-.313,13.969.81.81,0,0,1-1.117-.05.952.952,0,0,1,.063-1.357,7.869,7.869,0,0,0,.25-11.206Z",
    transform: "translate(8.163 1.32)",
    fill: "#2fda7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16039",
    "data-name": "Path 16039",
    d: "M11.673,8.75A2.923,2.923,0,1,0,14.6,11.673,2.923,2.923,0,0,0,11.673,8.75Z",
    transform: "translate(4.316 2.67)",
    fill: "#2fda7b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamingFilled);
export default __webpack_public_path__ + "static/media/Streaming-filled.b5fd8107099847631c1e5964ba131892.svg";
export { ForwardRef as ReactComponent };